import axios from 'axios';
import VueSuperagent from 'vue-superagent'
import store from '@/store';
import router from '@/router'
import Vue from "vue";

Vue.use(router);
Vue.use(VueSuperagent, {
    baseUrl: process.env.VUE_APP_API_BASE_URL
});

class ApiClient {
    constructor() {
        this.axiosBase = axios.create({
            baseURL: process.env.VUE_APP_API_BASE_URL,
        });
    }

    async initToken() {
        const result = this.axiosBase.get(
            '/posts',
        ).then(
            (res) => {
                return res;
            },
        ).catch(
            (err) => {
                return err;
            },
        );
        return result;
    }

    async get(endPoint, successCallback = null, failCallback = null) {
        document.querySelector('#connections').style.display = 'block';
        const header = {
            headers: {
                token: store.getters.getToken,
                contentType: 'application/json',
            }
        };
        const result = this.axiosBase.get(
            endPoint,
            header,
        ).then(
            (res) => {
                document.querySelector('#connections').style.display = 'none';
                if (!this._resultParse(res)) {
                    return ;
                }
                if (successCallback) {
                    successCallback(res);
                }
                return res.data.data;
            },
        ).catch(
            (err) => {
                document.querySelector('#connections').style.display = 'none';
                if (failCallback) {
                    failCallback(err);
                }
                alert('サーバーエラーが発生しました');
                return err;
            },
        );
        return result;
    }

    post(endPoint, addHeader = true, postParam = null) {
        document.querySelector('#connections').style.display = 'block';
        store.dispatch('setErrors', '')
        let header = {};
        if (addHeader) {
            header = {
                headers: {
                    token: store.getters.getToken,
                    contentType: 'application/json',
                }
            };
        }

        const params = new URLSearchParams();
        let json = '';
        if (postParam) {
            json = JSON.stringify(postParam);
        } else if (store.getters.getPostParam) {
            json = JSON.stringify(store.getters.getPostParam);
        }
        params.append('data', json);
        const result = this.axiosBase.post(
            endPoint,
            params,
            header,
        ).then(
            (res) => {
                document.querySelector('#connections').style.display = 'none';
                if (!this._resultParse(res)) {
                    return ;
                }
                store.dispatch('setErrors', res.data.data.errors);
                return res.data.data;
            },
        ).catch(
            (err) => {
                document.querySelector('#connections').style.display = 'none';
                alert('サーバーエラーが発生しました');
                return err;
            },
        );
        return result;
    }

    _resultParse(res) {
        if(res.data.data.state === 444 || res.data.data.state === 500) {
            router.push('/');
            return false;
        }
        store.dispatch('token', res.data.data._code);
        return true;
    }
}

export default ApiClient;
